import * as React from 'react';
import { Pressable, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { Text } from '@/ui';
import { Icon } from '@/ui/icon';
import { Search } from '@/ui/icons';

type SearchBarButtonProps = {
  onPress?: () => void;
  icon?: React.ReactNode;
  title?: string;
  caption?: string;
  style?: any;
  active?: boolean;
};

export const SearchBarButton = ({
  onPress,
  icon,
  title,
  caption,
  style,
  active,
}: SearchBarButtonProps) => {
  const { styles, theme } = useStyles(stylesheet);

  return (
    <Pressable
      onPress={onPress}
      style={[
        styles.container,
        {
          ...(active && {
            borderColor: theme.colors.input.active.border,
          }),
        },
        style,
      ]}
    >
      <View
        style={{
          flexDirection: 'row',
          gap: 8,
          padding: 16,
          paddingLeft: 10,
          alignItems: 'center',
        }}
      >
        <Icon
          type="dressed"
          icon={icon || <Search />}
          width={28}
          height={28}
          fillColor={theme.colors.icon.color}
        />

        <View>
          <>
            <Text type="bodyRegular" numberOfLines={1}>
              {title?.length > 30 ? `${title.slice(0, 30)}...` : title}
            </Text>

            {caption ? (
              <Text
                type="bodyRegular"
                style={{ color: theme.colors.text.secondary }}
              >
                {caption}
              </Text>
            ) : null}
          </>
        </View>
      </View>
    </Pressable>
  );
};

const stylesheet = createStyleSheet((theme) => ({
  container: {
    width: '100%',
    height: 60,
    borderRadius: 16,
    borderColor: theme.colors.input.default.border,
    borderWidth: 0.5,
    backgroundColor: theme.colors.background_2,
    justifyContent: 'center',
    overflow: 'hidden',
  },
}));
